import axios from 'axios';
import { Tag } from '../models/common-types';
import { TagToggle, TagAction } from '../contexts/useTags';

export interface TagsApi {
    fetchTags(wsId: number): Promise<Array<Tag>>;
    fetchAggregatedTags(wsId: number, caseId: string, streamId: string): Promise<Array<any>>;
    addTag(wsId: number, caseId: string, streamId: string, tagsData: TagToggle): Promise<any>;
    removeTag(wsId: number, caseId: string, streamId: string, tagsData: TagToggle): Promise<any>;
}

const baseUrl = `/api/osint/workspaces/`;

export class TagsAPI implements TagsApi {
    async fetchTags(wsId: number): Promise<Array<Tag>> {
        const { data } = await axios.get(`${baseUrl}${wsId}/tags`);
        return data?.tags || [];
    }

    async fetchAggregatedTags(wsId: number, caseId: string, streamId: string): Promise<Array<any>> {
        const { data } = await axios.get(`${baseUrl}${wsId}/cases/${caseId}/collections/${streamId}/tags`);
        return data?.tags || [];
    }

    async addTag(wsId: number, caseId: string, streamId: string, tagsData: TagToggle): Promise<any> {
        try {
            const response = await axios.post<any>(
                `${baseUrl}${wsId}/cases/${caseId}/collections/${streamId}/addTagToElement`,
                tagsData,
            );
            return response.data;
        } catch (error) {
            throw new Error('Failed to check tag');
        }
    }

    async removeTag(wsId: number, caseId: string, streamId: string, tagsData: TagToggle): Promise<any> {
        try {
            const response = await axios.delete<any>(
                `${baseUrl}${wsId}/cases/${caseId}/collections/${streamId}/removeTagFromElement`,
                { data: tagsData },
            );
            return response.data;
        } catch (error) {
            throw new Error('Failed to uncheck tag');
        }
    }

    async createTag(wsId: number, tagsData: TagAction) {
        try {
            const response = await axios.post<any>(`${baseUrl}${wsId}/tags`, tagsData);
            return response.data;
        } catch (error) {
            throw new Error('Failed to create tag');
        }
    }

    async editTag(wsId: number, tagsData: TagAction) {
        const tagId = tagsData.id;
        delete tagsData.id;
        try {
            const response = await axios.put<any>(`${baseUrl}${wsId}/tags/${tagId}`, tagsData);
            return response.data;
        } catch (error) {
            throw new Error('Failed to edit tag');
        }
    }
}
